<template>
  <div class="card">
    <div class="card-body">
      <div class="row row-previews">
        <div class="col-12">
          <label class="float-start text-start">Date de reservation :</label>
          <span class="float-start text-start " >{{date}}</span>
        </div>
        <div class="col-12">
          <label class="float-start text-start">Nom :</label>
          <span class="float-start text-start ">{{user.lastname}}</span>
        </div>
        <div class="col-12">
          <label class="float-start text-start">Prénom :</label>
          <span class="float-start text-start "> {{user.firname}}</span>
        </div>
        <div class="col-12">
          <label class="float-start text-start">Mobile :</label>
          <span class="float-start text-start ">{{user.formattedPhone}}</span>
        </div>
        <div class="col-12">
          <label class="float-start text-start">Autres Participants :</label>
          <span class="float-start text-start ">{{user.participants.length}} Participant(s)</span>
          <div class="row  section-participant">
            <div class="card mt-2 ml-5"  v-for="(participant, index) in  user.participants " :key="index">
              <div class="card-body">
                <div class="row row-previews" >
                  <div class="col-12">
                    <label class="float-start text-start">Nom :</label>
                    <span class="float-start text-start ">{{participant.lastname}}</span>
                  </div>
                  <div class="col-12">
                    <label class="float-start text-start">Prénom :</label>
                    <span class="float-start text-start "> {{participant.firname}}</span>
                  </div>
                  <div class="col-12">
                    <label class="float-start text-start">Mobile :</label>
                    <span class="float-start text-start ">{{participant.phone}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Previews",
        props: {
          date:Object,
          user:Object,
        }
    }
</script>
